import { Outlet, NavLink } from 'react-router-dom';
import { Camera, Settings } from 'lucide-react';

export default function AppShell() {
  return (
    <div className="app-shell">
      <main className="app-shell__main">
        <Outlet />
      </main>
      <nav className="tabbar">
        <NavLink
          to="/app"
          end
          className={({ isActive }) => `tabbar__btn ${isActive ? 'active' : ''}`}
        >
          <Camera size={22} />
          <span>Capture</span>
        </NavLink>
        <NavLink
          to="/settings"
          className={({ isActive }) => `tabbar__btn ${isActive ? 'active' : ''}`}
        >
          <Settings size={22} />
          <span>Settings</span>
        </NavLink>
      </nav>
    </div>
  );
}
